import { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";
import { useAuth } from "./AuthContext";
import { BarrioContext } from "./BarrioContext";

// Resuelve, para el Perfil Usuario (residente) logueado, su personaId y el
// flag `asamblea` en el barrio actualmente seleccionado — habilita el menu
// "Comunidad". Reusa spGetUFsByUsuario (ya se llama en el arranque para
// resolver la persona del usuario), extendido para traer tambien el flag.
//
// Tambien expone `sinAcceso`: true cuando el usuario logueado es un residente
// (rolId 2) pero no tiene ninguna unidad funcional asociada vigente (no
// asociado, o con fechaHasta vencida -- spGetUFsByUsuario filtra esos casos
// y no devuelve fila). Las pantallas del portal lo usan para mostrar un
// mensaje claro en vez de quedar mudas -- ver SinAccesoResidente.
export const PersonaResidenteContext = createContext();

export const PersonaResidenteProvider = ({ children }) => {
    const { rolId, usuarioId } = useAuth();
    const { barrio } = useContext(BarrioContext);
    const [personaId, setPersonaId] = useState(null);
    const [asambleaHabilitada, setAsambleaHabilitada] = useState(false);
    const [sinAcceso, setSinAcceso] = useState(false);
    const [resuelto, setResuelto] = useState(false);

    useEffect(() => {
        if (rolId !== 2 || !usuarioId || !barrio?.id) {
            setPersonaId(null);
            setAsambleaHabilitada(false);
            setSinAcceso(false);
            setResuelto(true);
            return;
        }
        // Se resetea antes de cada fetch para no dejar un "sinAcceso" viejo
        // colgado al cambiar de barrio mientras se resuelve el nuevo.
        setResuelto(false);
        setSinAcceso(false);
        const HOST_API = process.env.REACT_APP_URL;
        axios.get(`${HOST_API}api/unidadesFuncionales/GetUFsByUsuario`, {
            params: { usuarioId, barrioId: barrio.id },
        })
            .then(({ data }) => {
                const uf = (data ?? [])[0];
                const nuevaPersonaId = uf?.personaId ?? null;
                setPersonaId(nuevaPersonaId);
                setAsambleaHabilitada(!!uf?.asamblea);
                setSinAcceso(!nuevaPersonaId);
            })
            .catch(() => {
                setPersonaId(null);
                setAsambleaHabilitada(false);
                setSinAcceso(true);
            })
            .finally(() => setResuelto(true));
    }, [rolId, usuarioId, barrio?.id]);

    return (
        <PersonaResidenteContext.Provider value={{ personaId, asambleaHabilitada, sinAcceso, resuelto }}>
            {children}
        </PersonaResidenteContext.Provider>
    );
};

export const usePersonaResidente = () => useContext(PersonaResidenteContext);
